import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: '100%',
    margin: 0,
  },
}));

const switchStyles = makeStyles((theme) => ({
  label: {
    color: theme.palette.subtitle,
    fontSize: 13,
  },
}));

export { useStyles, switchStyles };
